module.exports = __webpack_public_path__ + "img/app/home/img/icon-gold.9c0d6c386b74107dcd6c925f10368517.png";